import { render } from "./stars.vue?vue&type=template&id=6e7f77cc&scoped=true&ts=true"
import script from "./stars.vue?vue&type=script&lang=ts"
export * from "./stars.vue?vue&type=script&lang=ts"

import "./stars.vue?vue&type=style&index=0&id=6e7f77cc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7f77cc"]])

export default __exports__